import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { Button } from '@src/shared/ui/components/Button';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React, { useState } from 'react';

import { Styles } from './includes/styles';

/**
 * PopoverContent
 *
 * @TODO Needs description.
 *
 * @param currentEntity
 * @param handleExport
 * @param setIsOpen
 * @returns {Element}
 * @constructor
 */
export function PopoverContent({ currentEntity = {}, handleExport = () => {}, setIsOpen = () => {} }) {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Styles>
      <Layout.Stack
        alignItems="left"
        alignLayout="left"
        grow
        space={Number(themeConfiguration?.theme?.space?.md) || 16}
      >
        <div>
          <Text fontWeight="bold">Warning:</Text>
        </div>
        <div>
          <Text>Risk record count is greater then one million items.</Text>
        </div>
        <div>
          <Checkbox
            isChecked={isChecked}
            label="Allow Export"
            onChange={(event) => {
              setIsChecked(event?.target?.checked);
            }}
            size="sm"
          />
        </div>
      </Layout.Stack>
      <Divider color="" height={1} margin={themeConfiguration?.theme?.space?.sm} />
      <Layout.Group alignLayout="right">
        <Button
          isDisabled={!isChecked}
          onClick={() => {
            setIsOpen(false);
            handleExport(currentEntity?.id);
          }}
          variant="solid"
        >
          Export
        </Button>
        <Button
          onClick={() => {
            setIsOpen(false);
          }}
          variant="outline"
        >
          Close
        </Button>
      </Layout.Group>
    </Styles>
  );
}
